import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row no-gutters" };
const _hoisted_2 = { class: "col-12 border-bottom py-4" };
const _hoisted_3 = { class: "h5-responsive" };
const _hoisted_4 = { class: "strong mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, [
                _cache[1] || (_cache[1] = _createTextVNode(" Zustand ", -1)),
                _createVNode(_component_open_popup_button, { "popup-name": "conditionsPopup" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                                src: "/images/_new_brand/icons/icon_fragezeichen_full.svg",
                                alt: "(?)",
                                width: "20",
                                height: "20",
                                class: "conditionsInfo pointerhover",
                                style: { "margin": "0 0 3px 0" }
                            }, null, -1)
                        ]))]),
                    _: 1
                })
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.textBeforeCondition) + _toDisplayString((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.condition), 1)
        ])
    ]));
}
